
import React, { useContext } from "react";
import getPmSession from "../../../common/utils/functions/getPmSession";
import { login_sso } from "../_redux/ssoCrud";
import { withTranslation } from "react-i18next";
import * as sso from "../_redux/ssoRedux";
import { compose } from "redux";
import { connect } from "react-redux";
import { AppConfig } from "../../../appConfig";
import { config } from "../../../config/config";
import { useHistory } from "react-router-dom";

function Sso(props) {
  const config= useContext(AppConfig);
  const history = useHistory()

 
// Function to extract parameters from URL
function getParameterByName(name, url) {
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}


  React.useEffect(() => {  
    var access_token = getParameterByName('access_token', window.location.hash);
    var status = getParameterByName('status', window.location.hash);
      if (status === "200" && access_token) {
         localStorage.setItem("access_token", access_token);
         getPmSession();
        props.handle_reset_store();
        history.push("/inbox");
         window.location.replace("/#/inbox");
      }
      else
      window.location.replace("/#/inbox");
  }, []);

  return (
    <div className="d-flex align-items-center justify-content-center text-center">
      <h6 className="my-auto">در حال بارگذاری</h6>
    </div>
  );
}

export default compose(withTranslation(), connect(null, sso.actions))(Sso);
